export default "__VITE_ASSET__4b0f978f__"